import styled from 'styled-components';

import { MobileScreen } from '@shared/components/styles/ConstantMediaQuery';
import ColorConstants from '@shared/constants/ColorConstants';

const getColor = ({ isDesktop }) => (
    isDesktop ? ColorConstants['black-50%'] : ColorConstants.white
);

export const AccountInfoMetricWrapper = styled.div`
    margin-right: ${({ marginRight = '70px' }) => marginRight};
    color: ${getColor};
    font-family: 'Helvetica';
    font-size: 14px;

    @media screen and (max-width: 800px) {
        margin-right: 50px;
    }

    @media ${MobileScreen} {
        margin-right: 30px;
    }
`;

export const AccountInfoMetricTitle = styled.h4`
    color: ${getColor};
    font-family: 'Helvetica';
    font-size: 12px;
    margin: 0;
    text-align: center;
`;

export const AccountInfoMetricValue = styled.span`
    align-items: center;
    color: ${getColor};
    font-family: 'Helvetica';
    display: flex;
    font-size: 12px;
    justify-content: center;

    @media ${MobileScreen} {
        white-space: nowrap;
    }
`;
